'use strict';

var _extends = require('@babel/runtime/helpers/extends');
var _slicedToArray = require('@babel/runtime/helpers/slicedToArray');
var _objectWithoutProperties = require('@babel/runtime/helpers/objectWithoutProperties');
var React = require('react');
require('./SymbolsCounter.style-64b0606b.js');
var Affix = require('./Affix-535aba61.js');
var InputStatusIcon = require('./InputStatusIcon-f8340fe4.js');
var useEventHandlers = require('./useEventHandlers-fe0dbdf6.js');
var useControllableStateAsEvent = require('./useControllableStateAsEvent-37d110e1.js');
var react = require('@emotion/react');
var parseDataAttributes = require('./parseDataAttributes-81c8dbee.js');
var getReactNode = require('./getReactNode-625f4d64.js');
var _taggedTemplateLiteral = require('@babel/runtime/helpers/taggedTemplateLiteral');
var styled = require('@emotion/styled');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var _slicedToArray__default = /*#__PURE__*/_interopDefaultLegacy(_slicedToArray);
var _objectWithoutProperties__default = /*#__PURE__*/_interopDefaultLegacy(_objectWithoutProperties);
var _taggedTemplateLiteral__default = /*#__PURE__*/_interopDefaultLegacy(_taggedTemplateLiteral);
var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var _templateObject;
var TextInputWrapper = styled__default["default"].div(_templateObject || (_templateObject = _taggedTemplateLiteral__default["default"](["\n    --focusColor: ", ";\n    --textColor: ", ";\n    --size: ", ";\n\n    background: ", ";\n    border: none;\n    border-radius: ", ";\n    box-sizing: border-box;\n    display: inline-block;\n    font-family: ", ";\n    font-size: ", ";\n    line-height: ", ";\n    position: relative;\n    vertical-align: top;\n    width: inherit;\n\n    &[data-textinput-full-width='true'] {\n        display: block;\n    }\n\n    &[data-textinput-background='white'] {\n        background: ", ";\n    }\n\n    & .n-textinput-layout {\n        display: flex;\n        width: 100%;\n    }\n\n    & .n-textinput-affix {\n        flex: none;\n        padding: ", ";\n\n        &--pre {\n            padding-right: ", ";\n        }\n\n        &--suf {\n            padding-left: ", ";\n        }\n\n        & svg {\n            height: var(--size);\n            width: var(--size);\n        }\n    }\n\n    & .n-textinput-input {\n        background: transparent;\n        border: none;\n        box-sizing: content-box;\n        color: var(--textColor);\n        flex: auto;\n        font: inherit;\n        height: var(--size);\n        outline: none;\n        padding: ", ";\n        width: 100%;\n\n        &::placeholder {\n            color: ", ";\n        }\n\n        &:disabled,\n        &:read-only {\n            --textColor: ", ";\n\n            &::placeholder {\n                color: var(--textColor);\n            }\n        }\n\n        &[data-textinput-has-suffix='true'] {\n            padding-right: ", ";\n        }\n\n        &:focus + .n-textinput-focus,\n        &:focus-visible + .n-textinput-focus {\n            opacity: 1;\n        }\n\n        &[aria-invalid='true'] {\n            &:focus + .n-textinput-focus,\n            &:focus-visible + .n-textinput-focus {\n                --focusColor: ", ";\n\n                @media (forced-colors: active) {\n                    --focusColor: FieldText;\n                }\n            }\n        }\n    }\n\n    & .n-textinput-affix + .n-textinput-input {\n        padding-left: ", ";\n    }\n\n    & .n-textinput-focus {\n        background: var(--focusColor);\n        bottom: 0;\n        height: ", ";\n        left: 0;\n        opacity: 0;\n        position: absolute;\n        right: 0;\n    }\n\n    & .n-textinput-status-wrapper {\n        box-sizing: content-box;\n        flex: none;\n        height: var(--size);\n        padding: ", ";\n        width: var(--size);\n\n        &:last-of-type {\n            padding-right: ", ";\n        }\n    }\n\n    @media (forced-colors: active) {\n        --focusColor: FieldText;\n        --textColor: FieldText;\n\n        background: Field;\n        border: 1px solid FieldText;\n\n        & .n-textinput-layout {\n            margin: -1px;\n        }\n\n        & .n-textinput-affix,\n        & svg {\n            color: CanvasText;\n        }\n\n        &:disabled {\n            --textColor: GrayText;\n\n            & .n-textinput-affix,\n            & svg {\n                color: GrayText;\n            }\n        }\n    }\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.colors['borders-brand-primary'];
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors['text-global-primary'];
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.space[24];
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.colors['background-global-secondary'];
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.radii.medium;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.fonts.family;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.typography.p2.fontSize;
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.typography.p2.lineHeight;
}, function (_ref9) {
  var theme = _ref9.theme;
  return theme.colors['background-global-primary'];
}, function (_ref10) {
  var theme = _ref10.theme;
  return "".concat(theme.space[12], " ").concat(theme.space[16]);
}, function (_ref11) {
  var theme = _ref11.theme;
  return theme.space[0];
}, function (_ref12) {
  var theme = _ref12.theme;
  return theme.space[0];
}, function (_ref13) {
  var theme = _ref13.theme;
  return "".concat(theme.space[10], " ").concat(theme.space[16], " ").concat(theme.space[14], " ").concat(theme.space[16], " ");
}, function (_ref14) {
  var theme = _ref14.theme;
  return theme.colors['text-global-secondary'];
}, function (_ref15) {
  var theme = _ref15.theme;
  return theme.colors['text-global-disabled'];
}, function (_ref16) {
  var theme = _ref16.theme;
  return theme.space[8];
}, function (_ref17) {
  var theme = _ref17.theme;
  return theme.colors['borders-global-error'];
}, function (_ref18) {
  var theme = _ref18.theme;
  return theme.space[8];
}, function (_ref19) {
  var theme = _ref19.theme;
  return theme.borderWidths.medium;
}, function (_ref20) {
  var theme = _ref20.theme;
  return "".concat(theme.space[12], " ").concat(theme.space[8], " ").concat(theme.space[12], " ").concat(theme.space[0]);
}, function (_ref21) {
  var theme = _ref21.theme;
  return theme.space[16];
});

var _excluded = ["type", "prefix", "suffix", "disabled", "value", "onChange", "onFocus", "onBlur", "onKeyDown", "onKeyUp", "defaultValue", "className", "validationStatus", "dataAttributes", "readOnly", "fullWidth", "background", "aria-invalid"];
var TextInput = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'text' : _ref$type,
    prefix = _ref.prefix,
    suffix = _ref.suffix,
    disabled = _ref.disabled,
    valueProp = _ref.value,
    _ref$onChange = _ref.onChange,
    onChange = _ref$onChange === void 0 ? function () {} : _ref$onChange,
    _ref$onFocus = _ref.onFocus,
    onFocus = _ref$onFocus === void 0 ? function () {} : _ref$onFocus,
    _ref$onBlur = _ref.onBlur,
    onBlur = _ref$onBlur === void 0 ? function () {} : _ref$onBlur,
    _ref$onKeyDown = _ref.onKeyDown,
    onKeyDown = _ref$onKeyDown === void 0 ? function () {} : _ref$onKeyDown,
    _ref$onKeyUp = _ref.onKeyUp,
    onKeyUp = _ref$onKeyUp === void 0 ? function () {} : _ref$onKeyUp,
    defaultValue = _ref.defaultValue,
    className = _ref.className,
    validationStatus = _ref.validationStatus,
    _ref$dataAttributes = _ref.dataAttributes,
    dataAttributes = _ref$dataAttributes === void 0 ? {} : _ref$dataAttributes,
    readOnly = _ref.readOnly,
    fullWidth = _ref.fullWidth,
    background = _ref.background,
    ariaInvalid = _ref['aria-invalid'],
    nativeProps = _objectWithoutProperties__default["default"](_ref, _excluded);
  var hasStatusIcon = !!validationStatus;
  var hasError = validationStatus === 'hasError';
  var hasSuffix = hasStatusIcon || !!suffix;
  var _useControllableState = useControllableStateAsEvent.useControllableStateAsEvent({
      value: valueProp,
      defaultValue: defaultValue,
      onChange: onChange
    }),
    _useControllableState2 = _slicedToArray__default["default"](_useControllableState, 2),
    value = _useControllableState2[0],
    setValue = _useControllableState2[1];
  var dataAttributesParsed = parseDataAttributes.parseDataAttributes(dataAttributes);
  var handleChange = React.useCallback(function (event) {
    setValue(event.target.value, event);
  }, [setValue]);
  var _useEventHandlers = useEventHandlers.useEventHandlers({
      onFocus: onFocus,
      onBlur: onBlur,
      onKeyDown: onKeyDown,
      onKeyUp: onKeyUp
    }),
    handleFocus = _useEventHandlers.handleFocus,
    handleBlur = _useEventHandlers.handleBlur,
    handleKeyDown = _useEventHandlers.handleKeyDown,
    handleKeyUp = _useEventHandlers.handleKeyUp;
  return react.jsx(TextInputWrapper, {
    className: className,
    "data-textinput-full-width": fullWidth,
    "data-textinput-background": background
  }, react.jsx("div", {
    className: "n-textinput-layout"
  }, !!prefix && react.jsx(Affix.Affix, {
    disabled: disabled || readOnly,
    className: "n-textinput-affix n-textinput-affix--pre"
  }, getReactNode.getReactNode(prefix)), react.jsx("input", _extends__default["default"]({}, nativeProps, dataAttributesParsed, {
    className: "n-textinput-input",
    ref: ref,
    type: type,
    disabled: disabled,
    readOnly: readOnly,
    value: value !== null && value !== void 0 ? value : '',
    onChange: handleChange,
    onFocus: handleFocus,
    onBlur: handleBlur,
    onKeyDown: handleKeyDown,
    onKeyUp: handleKeyUp,
    "aria-invalid": ariaInvalid || hasError,
    "data-textinput-has-suffix": hasSuffix
  })), react.jsx("div", {
    className: "n-textinput-focus"
  }), hasStatusIcon && react.jsx("div", {
    className: "n-textinput-status-wrapper"
  }, react.jsx(InputStatusIcon.InputStatusIcon, {
    status: validationStatus,
    "aria-hidden": true
  })), !!suffix && react.jsx(Affix.Affix, {
    disabled: disabled || readOnly,
    className: "n-textinput-affix n-textinput-affix--suf"
  }, getReactNode.getReactNode(suffix))));
});

exports.TextInput = TextInput;
//# sourceMappingURL=TextInput-368d2d41.js.map
